export interface AxiomDef {
  id: string;
  /** the rule itself, as the world sees it */
  rule: { en: string; pt: string };
  /** how it shows up in mechanics, in one line */
  hint: { en: string; pt: string };
  cost: number;
}

export const AXIOMS: AxiomDef[] = [
  {
    id: 'noDecay',
    rule: {
      en: 'Items do not decay.',
      pt: 'Itens não decaem.',
    },
    hint: {
      en: '+10% global production (placeholder for inventory durability).',
      pt: '+10% produção global (proxy para durabilidade de inventário).',
    },
    cost: 1,
  },
  {
    id: 'marketsAlwaysStock',
    rule: {
      en: 'Markets always have stock.',
      pt: 'Mercados sempre têm estoque.',
    },
    hint: {
      en: 'Market demand floor +0.15 (lowest demand never goes below 0.95).',
      pt: 'Piso da demanda do mercado +0.15 (mínimo nunca abaixo de 0.95).',
    },
    cost: 2,
  },
  {
    id: 'craftMomentum',
    rule: {
      en: 'The first craft of any session retains its full intention.',
      pt: 'O primeiro ofício de qualquer sessão guarda toda a sua intenção.',
    },
    hint: {
      en: 'First craft of each session yields ×3 Φ.',
      pt: 'Primeiro craft de cada sessão rende ×3 Φ.',
    },
    cost: 3,
  },
  {
    id: 'reflexiveAmplifies',
    rule: {
      en: 'The Engine pays double attention to itself.',
      pt: 'A Máquina presta atenção dupla a si mesma.',
    },
    hint: {
      en: 'Reflexive Φ yield ×2.',
      pt: 'Φ Reflexivo rende ×2.',
    },
    cost: 5,
  },
  {
    id: 'framesInherited',
    rule: {
      en: 'Frames inherit. Form is older than content.',
      pt: 'Os Frames são herdados. A forma é mais velha que o conteúdo.',
    },
    hint: {
      en: 'Each Recompile keeps 50% of accumulated Frames.',
      pt: 'Cada Recompile preserva 50% dos Frames acumulados.',
    },
    cost: 5,
  },
  {
    id: 'stewardsRemember',
    rule: {
      en: 'Stewards remember at least one hire.',
      pt: 'Mãos lembram de ao menos uma contratação.',
    },
    hint: {
      en: 'Each Recompile, unlocked stewards start at level 1.',
      pt: 'A cada Recompile, mãos desbloqueadas começam no nível 1.',
    },
    cost: 5,
  },
  {
    id: 'stewardsOneTrick',
    rule: {
      en: 'Stewards know one trick well.',
      pt: 'Mãos dominam um truque.',
    },
    hint: {
      en: 'Steward cycle time reduced by 15%.',
      pt: 'Tempo de ciclo das mãos reduzido em 15%.',
    },
    cost: 3,
  },
  {
    id: 'reactorsLinger',
    rule: {
      en: 'Reactors linger between compiles.',
      pt: 'Reatores permanecem entre compilações.',
    },
    hint: {
      en: 'Recompile keeps reactor levels at 25%.',
      pt: 'Recompile preserva 25% dos níveis dos reatores.',
    },
    cost: 5,
  },
  {
    id: 'goldEcho',
    rule: {
      en: 'Coin keeps an echo of itself.',
      pt: 'A moeda guarda um eco de si.',
    },
    hint: {
      en: 'Realign keeps 10% of accumulated coin.',
      pt: 'Realign preserva 10% das moedas acumuladas.',
    },
    cost: 3,
  },
  {
    id: 'doubleObserver',
    rule: {
      en: 'The observer can be observed.',
      pt: 'O observador pode ser observado.',
    },
    hint: {
      en: 'Observer reactor effect ×1.5 (compounds with its own multiplier).',
      pt: 'Efeito do reator Observador ×1.5 (compõe com seu próprio multiplicador).',
    },
    cost: 7,
  },
  {
    id: 'recipesPersist',
    rule: {
      en: 'Authorship persists across realigns.',
      pt: 'A autoria persiste entre realinhamentos.',
    },
    hint: {
      en: 'User-defined recipes survive Realign (but not Recompile).',
      pt: 'Receitas autorais sobrevivem ao Realign (mas não ao Recompile).',
    },
    cost: 4,
  },
  {
    id: 'wideAperture',
    rule: {
      en: 'The Engine reads wider than the ledger.',
      pt: 'A Máquina lê mais largo que o livro-razão.',
    },
    hint: {
      en: 'Encounter auto-rate in Act III/IV: 0.4 → 0.7 steps/sec.',
      pt: 'Taxa automática de jornadas em Ato III/IV: 0.4 → 0.7 passos/s.',
    },
    cost: 6,
  },
  {
    id: 'cheapPrimitive',
    rule: {
      en: 'Authorship is cheaper than memory.',
      pt: 'A autoria custa menos que a memória.',
    },
    hint: {
      en: 'Recipe authorship cost: 30 Φ → 15 Φ per primitive.',
      pt: 'Custo de autorar receita: 30 Φ → 15 Φ por primitivo.',
    },
    cost: 4,
  },
  {
    id: 'preservedSurvives',
    rule: {
      en: 'What is preserved cannot be unpreserved.',
      pt: 'O preservado não pode ser despreservado.',
    },
    hint: {
      en: 'Sword of First Cut survives Realign (but not Recompile).',
      pt: 'A Espada do Primeiro Corte sobrevive ao Realign (não ao Recompile).',
    },
    cost: 3,
  },
];

export function axiomById(id: string): AxiomDef | undefined {
  return AXIOMS.find((a) => a.id === id);
}
